import React from 'react'

export default function Title() {
  return (
    <div className='Title'>
      <div className="title-bg">
        <div className="container">
          <h2>Toshkentda eng arzon va qiziqarliy turlar</h2>
          <p>Faqat eng yaxshilarini tanlash kerak...</p>
        </div>
      </div>
    </div>
  )
}
